import { render, staticRenderFns } from "./LegalAdvice.vue?vue&type=template&id=ab318e8c&scoped=true"
import script from "./LegalAdvice.vue?vue&type=script&lang=js"
export * from "./LegalAdvice.vue?vue&type=script&lang=js"
import style0 from "./LegalAdvice.vue?vue&type=style&index=0&id=ab318e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab318e8c",
  null
  
)

export default component.exports